import { render, staticRenderFns } from "./openMore.vue?vue&type=template&id=6b48967c&scoped=true&"
import script from "./openMore.vue?vue&type=script&lang=js&"
export * from "./openMore.vue?vue&type=script&lang=js&"
import style0 from "./openMore.vue?vue&type=style&index=0&id=6b48967c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b48967c",
  null
  
)

export default component.exports